module.exports = __webpack_public_path__ + "static/media/minus.5252db72.svg";